import React, { useState, useEffect, useRef } from 'react';
import { requestForToken, onMessageListener } from '../firebase';
import NotificationSound from '../assets/audio/web_whatsapp.mp3';
import { Button, notification } from 'antd';
import { useTranslation } from 'react-i18next';
import { ShoppingCartOutlined } from '@ant-design/icons';
import { del, set } from 'idb-keyval';
import { useDispatch } from 'react-redux';
import { addMenu } from '../redux/slices/menu';
import { useNavigate } from 'react-router-dom';

export default function PushNotification({ refetch }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState({ title: '', body: '' });
  const audioPlayer = useRef(null);

  const deleteItem = (id) => {
    del(id).then(() => refetch());
  };

  const goToShow = (title, delivery_type) => {
    console.log("delivery_type = "+delivery_type)
    var id = title.split("# ")[1]
    deleteItem(id);
    dispatch(
      addMenu({
        url: delivery_type == "delivery" ? `orders/delivery` : `orders/point`,
        id: delivery_type == "delivery" ? "order-list-delivery" : 'order-list-pickup',
        name: delivery_type == "delivery" ? t('delivery.orders') : t(`pickup.orders`),
      })
    );
    // navigate(`/order/details/${id}`);
    var url = delivery_type == "delivery" ? `/orders/delivery` : `/orders/point`
    navigate(url);
  };

  const goToParcel = (id) => {
    deleteItem(id);
    dispatch(
      addMenu({
        url: `parcel-orders`,
        id: 'parcel_orders',
        name: t('parcel.orders'),
      })
    );
    navigate(`/parcel-orders`);
  };

  const close = () => {
    console.log('Notification was closed');
    audioPlayer.current.pause();
  };

  const notifyOrder = () => {
    audioPlayer.current.play();
    const key = `open${Date.now()}`;
    const btn = (
      <Button
        type='primary'
        size='small'
        onClick={() => {
          audioPlayer.current.pause();
          notification.close(key);
          goToShow(data.title, data.delivery_type);
        }}
      >
        {t('view.order')}
      </Button>
    );
    notification.open({
      message: t('new.order'),
      description: `${t('order.id')} #${data.title}`,
      btn,
      key,
      onClose: close,
      duration: 0,
      icon: (
        <ShoppingCartOutlined
          style={{
            color: '#3e79f7',
          }}
        />
      ),
    });
  };

  const notifyParcel = () => {
    audioPlayer.current.play();
    const key = `open${Date.now()}`;
    const btn = (
      <Button
        type='primary'
        size='small'
        onClick={() => {
          audioPlayer.current.pause();
          notification.close(key);
          goToParcel();
        }}
      >
        {t('view.parcel')}
      </Button>
    );
    notification.open({
      message: t('new.parcel'),
      description: `${t('parcel.id')} #${data.title}`,
      btn,
      key,
      onClose: close,
      duration: 0,
      icon: (
        <ShoppingCartOutlined
          style={{
            color: '#3e79f7',
          }}
        />
      ),
    });
  };

  useEffect(() => {
    if (data?.title) {
      const isParcel = data.body?.includes('parcel');
      isParcel ? notifyParcel() : notifyOrder();
    }
  }, [data]);

  useEffect(() => {
    requestForToken();
  }, []);

  onMessageListener()
    .then((payload) => {
      console.log(payload)
      const title = payload?.notification?.title;
      const body = payload?.notification?.body;
      const delivery_type = payload?.data?.delivery_type;
      const id = payload?.data?.id;
      setData({
        id,
        title,
        body,
        delivery_type
      });
      set(title, body, delivery_type);
      refetch();
    })
    .catch((err) => console.log('failed: ', err));

  return (
    <div className='notification'>
      <audio
        id='notification-audio'
        ref={audioPlayer}
        src={NotificationSound}
        loop={true}
      />
    </div>
  );
}
